import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import './Bank.css';

const url = process.env.REACT_APP_BACKEND_URL;

const Bank = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const [data, setData] = useState({
    bankname: '',
    bankaccountno: '',
    description: ''
  });

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!data.bankname?.trim()) {
      toast.error('Bank Name is required');
      return;
    }
    if (!data.bankaccountno?.trim()) {
      toast.error('Bank Account Number is required');
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post(`${url}/api/bank`, data);

      if (response.data.success) {
        toast.success('Bank added successfully!');
        setData({
          bankname: '',
          bankaccountno: '',
          description: ''
        });
        navigate('/ViewBank');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to add bank';
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bank-container">
      <div className="header">
        <h2>Add New Bank</h2>
        <button onClick={() => navigate('/ViewBank')} className="add-button">
          <Plus size={16} /> View Banks
        </button>
      </div>

      <form className="bank-form" onSubmit={onSubmitHandler}>
        <div className="form-group">
          <label>Bank Name *</label>
          <input
            type="text"
            name="bankname"
            value={data.bankname}
            onChange={onChangeHandler}
            placeholder="Enter bank name"
            required
          />
        </div>

        <div className="form-group">
          <label>Phone Number *</label>
          <input
            type="text"
            name="bankaccountno"
            value={data.bankaccountno}
            onChange={onChangeHandler}
            placeholder="Enter bank account number"
            required
          />
        </div>

        <div className="form-group">
          <label>Description (Optional)</label>
          <textarea
            name="description"
            value={data.description}
            onChange={onChangeHandler}
            placeholder="Enter description"
            rows="3"
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={submitting}>
            {submitting ? "Adding..." : "Add Bank"}
          </button>
          <button
            type="button"
            onClick={() => navigate('/ViewBank')}
            className="cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Bank;